import { render, staticRenderFns } from "./LeadWebsite.vue?vue&type=template&id=36714e31"
import script from "./LeadWebsite.vue?vue&type=script&lang=js"
export * from "./LeadWebsite.vue?vue&type=script&lang=js"
import style0 from "./LeadWebsite.vue?vue&type=style&index=0&id=36714e31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports